import { render, staticRenderFns } from "./PhotosCarouselModal.vue?vue&type=template&id=260f1325&scoped=true"
import script from "./PhotosCarouselModal.vue?vue&type=script&lang=js"
export * from "./PhotosCarouselModal.vue?vue&type=script&lang=js"
import style0 from "./PhotosCarouselModal.vue?vue&type=style&index=0&id=260f1325&prod&lang=scss"
import style1 from "./PhotosCarouselModal.vue?vue&type=style&index=1&id=260f1325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f1325",
  null
  
)

export default component.exports